module.exports = __webpack_public_path__ + "static/p6_chart2-cf6bbdfe1b587271f7d19cb6b12269bf.png";